import { isErrorStatus, isLoadingStatus, useResource } from 'json-api-hooks';
import React, { FC } from 'react';
import { useParams } from 'react-router';

import Document from '../../../components/Document';
import ErrorPage from '../../../components/Error/ErrorPage';
import { LoadingPage } from '../../../components/Loading';

const PageShow: FC = () => {
  const { id } = useParams();
  const [page, status] = useResource({ type: 'pages', id });

  if (isLoadingStatus(status)) {
    return <LoadingPage />;
  }

  if (isErrorStatus(status) || !page) {
    return <ErrorPage />;
  }

  return <Document content={page.attributes.body} title={page.attributes.title} />;
};

export default PageShow;
